import { render, staticRenderFns } from "./ExercisesPage.vue?vue&type=template&id=90bd4694"
import script from "./ExercisesPage.vue?vue&type=script&lang=js"
export * from "./ExercisesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports